import { Trans } from 'next-i18next'

import {
  Heading3,
  LinkText,
  Paragraph,
  Section3
} from '@/features/Listings/seo/elements'
import getFilterLinks from '@/features/Listings/seo/search-results-content/content/get-filter-links'
import useFilterSlug from '@/features/Listings/seo/search-results-content/content/use-filter-slug'

const AverageRentFaqTemp = ({
  filterSlug,
  isCanadaPage = false,
  cityName,
  cityNameWithState,
  citySlug,
  neighbourhoodSlug,
  rentAmounts,
  rentReportLink
}) => {
  const links = getFilterLinks(isCanadaPage, citySlug, neighbourhoodSlug)
  const { hasFilter, filterName } = useFilterSlug(filterSlug)

  return (
    <>
      {hasFilter ? (
        <Section3>
          <Heading3>
            <Trans
              i18nKey="seo:What is the average rent in LOCATION for FILTER?"
              values={{
                filter: filterName,
                location: cityName
              }}
              defaults="What is the average rent in {{ location }} for {{ filter }}?"
            />
          </Heading3>
          <Paragraph>
            <Trans i18nKey="seo:Average rent in LOCATION for FILTER custom paragraph 2">
              The average rent in {{ cityNameWithState }} for {{ filterName }}{' '}
              will vary on a month-to-month basis. Check out our{' '}
              <LinkText href={rentReportLink}>monthly rent reports</LinkText>.
              We will soon be adding {{ cityName }}!
            </Trans>
          </Paragraph>
        </Section3>
      ) : (
        <>
          <Section3>
            <Heading3>
              <Trans
                i18nKey="seo:What is the average rent for 1 bedroom apartment LOCATION?"
                values={{
                  location: cityName
                }}
                defaults="What is the average rent for 1 bedroom apartment {{ location }}?"
              />
            </Heading3>
            <Paragraph>
              <Trans i18nKey="seo:Average Rent 1 Bed CITY Paragraph 2">
                The average rent for a{' '}
                <LinkText href={links.bed1}>
                  1 bedroom apartment in {{ cityNameWithState }}
                </LinkText>{' '}
                is between {{ rentAmounts: rentAmounts.bed1 }}. Check out our{' '}
                <LinkText href={rentReportLink}>monthly rent reports</LinkText>.
                We will soon be adding {{ cityName }}!
              </Trans>
            </Paragraph>
          </Section3>
          <Section3>
            <Heading3>
              <Trans
                i18nKey="seo:What is the average rent for 2 bedroom apartment LOCATION?"
                values={{
                  location: cityName
                }}
                defaults="What is the average rent for 2 bedroom apartment {{ location }}?"
              />
            </Heading3>
            <Paragraph>
              <Trans i18nKey="seo:Average Rent 2 Bed CITY Paragraph 2">
                The average rent for a{' '}
                <LinkText href={links.bed2}>
                  2 bedroom apartment in {{ cityNameWithState }}
                </LinkText>{' '}
                is between {{ rentAmounts: rentAmounts.bed2 }}. Check out our{' '}
                <LinkText href={rentReportLink}>monthly rent reports</LinkText>.
                We will soon be adding {{ cityName }}!
              </Trans>
            </Paragraph>
          </Section3>
          <Section3>
            <Heading3>
              <Trans
                i18nKey="seo:What is the average rent for 3 bedroom apartment LOCATION?"
                values={{
                  location: cityName
                }}
                defaults="What is the average rent for 3 bedroom apartment {{ location }}?"
              />
            </Heading3>
            <Paragraph>
              <Trans i18nKey="seo:Average Rent 3 Bed CITY Paragraph 2">
                The average rent for a{' '}
                <LinkText href={links.bed3}>
                  3 bedroom apartment in {{ cityNameWithState }}
                </LinkText>{' '}
                is between {{ rentAmounts: rentAmounts.bed3 }}. Check out our{' '}
                <LinkText href={rentReportLink}>monthly rent reports</LinkText>.
                We will soon be adding {{ cityName }}!
              </Trans>
            </Paragraph>
          </Section3>
        </>
      )}
    </>
  )
}

export default AverageRentFaqTemp
